const WEBSHOP_ADDRESSES_TOGGLE_DATA_ATTRIBUTE = 'webshop-invite-addresses-equal';
const WEBSHOP_ADDRESSES_CONTAINER_DATA_ATTRIBUTE = 'webshop-invite-address-container';
const HIDE_CLASS = 'hidden';

function toggleAddresses(event) {
    const containers = document.querySelectorAll(`[${WEBSHOP_ADDRESSES_CONTAINER_DATA_ATTRIBUTE}]`);
    containers.forEach((container) => {
        if (container.getAttribute(WEBSHOP_ADDRESSES_CONTAINER_DATA_ATTRIBUTE) > 0) {
            container.classList.toggle(HIDE_CLASS, event.value);
        }
    });
}

export default function initAddressesToggle() {
    document.addEventListener('DOMContentLoaded', () => {
        const toggle = document.querySelector(`[${WEBSHOP_ADDRESSES_TOGGLE_DATA_ATTRIBUTE}]`);
        if (!toggle) {
            return;
        }
        toggleAddresses({ value: toggle.value });
        toggle.addEventListener('change', (e) => toggleAddresses(e));
    });
}
